import { queryOptions } from '@tanstack/react-query';

import * as bookingFeedbackApi from './booking-feedback.api';
import * as feedbackApi from './feedback.api';

/** Every feedback query key, built in one place. */
export const feedbackKeys = {
  all: ['feedback'] as const,
  form: (token: string) => [...feedbackKeys.all, 'form', token] as const,
  bookingForm: (token: string) => [...feedbackKeys.all, 'booking-form', token] as const,
};

export const feedbackQueries = {
  /**
   * The form behind one emailed link. Never refetched on its own: a guest
   * part-way through their answers should not have the questions swapped
   * under them.
   */
  form: (token: string) =>
    queryOptions({
      queryKey: feedbackKeys.form(token),
      queryFn: () => feedbackApi.getFeedbackForm(token),
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      // A bad link stays bad; asking three more times only delays the message.
      retry: false,
    }),
  /** The same, for the link in the booking feedback email. */
  bookingForm: (token: string) =>
    queryOptions({
      queryKey: feedbackKeys.bookingForm(token),
      queryFn: () => bookingFeedbackApi.getBookingFeedbackForm(token),
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    }),
};
